import { render, staticRenderFns } from "./WPBaseRadio.vue?vue&type=template&id=52d8f0ec"
import script from "./WPBaseRadio.vue?vue&type=script&lang=ts"
export * from "./WPBaseRadio.vue?vue&type=script&lang=ts"
import style0 from "./WPBaseRadio.vue?vue&type=style&index=0&id=52d8f0ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports